import React from "react";
import { useParams } from "react-router";

import ManualClaimLayout from "@/App/layouts/ManualClaim";
import FileDownload from "./FileDownload";

interface UrlParams {
  id?: string;
}

const ViewBatchClaims: React.FC = () => {
  const { id }: UrlParams = useParams();

  return (
    <ManualClaimLayout selected="rightToggle">
      <FileDownload fileID={id} />
    </ManualClaimLayout>
  );
};

export default ViewBatchClaims;
